<template>
  <div class="card">
    <notification-badge
      class="cardNotification"
      :notificationNumber="getNumOfNotifications"
      v-if="getNumOfNotifications"
    ></notification-badge>
    <div class="image-wrapper">
      <i class="image" :class="image"></i>
    </div>
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
import notificationBadge from '@/components/common/NotificationBadge';
export default {
  components: {
    notificationBadge
  },
  computed: {
    getNumOfNotifications() {
      switch (this.title) {
        case 'Tiketi':
          return this.$store.getters.getNumOfTicketNotificationsByCommunity(
            this.$route.params.id
          );
        case 'Glasanja':
          return this.$store.getters.getNumOfPollsNotificationsByCommunity(
            this.$route.params.id
          );
        case 'Stanari':
          return this.$store.getters.getNumOfMemberNotificationsByCommunity(
            this.$route.params.id
          );
      }
      return 0;
    }
  },
  props: {
    title: { type: String, required: true },
    image: { type: String, required: true }
  }
};
</script>

<style scoped lang="scss">
.card {
  margin: 10px;
  border-color: var(--primary-color);
  width: 220px;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  transition: transform 0.15s, border-width 0.15s;
}

.cardNotification {
  position: absolute;
  right: -0.725em;
  top: -0.725em;
}

.card:hover {
  transform: scale(1.05);
  border-width: 3px;
  cursor: pointer;
}

.card:hover .image-wrapper {
  color: white;
  background-color: var(--primary-color-lighten);
}

.image-wrapper {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
}

i.image {
  height: 150px;
  width: 150px;
  font-size: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
